// CANONICAL COPY (GH #7115). src/constants/obligations/obl-ai-risk-management.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-ai-risk-management',
  title: 'Operate the AI risk management system',
  description:
    'Confirm that a continuous, iterative risk management system is established, documented and maintained across the whole lifecycle of every high-risk AI system (EU AI Act Art. 9). It shall identify and analyse the known and reasonably foreseeable risks to health, safety and fundamental rights, evaluate risks from intended use and reasonably foreseeable misuse, adopt targeted risk-management measures, and be updated with information from post-market monitoring. This is distinct from a point-in-time AI impact assessment: the process runs and is re-run throughout development and operation. Review the AI risk-management procedure, the current AI risk records and evidence that they are refreshed on change and from monitoring.',
  category: 'risk',
  scfIds: ['SCF-AIG-018'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'AI risk-management procedure is published' },
    { type: 'document-approved', description: 'Procedure has been approved' },
    { type: 'document-within-sla', description: 'Procedure review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
